import React from "react";
import FormSelect from "./FormSelect";
import useMapContext from "../hooks/useMapContext";
import { Button, ButtonGroup, IconButton } from "@chakra-ui/react";
import { FaTimes } from "react-icons/fa";

export const Filters = () => {
  const mapFilters = useMapContext();
  return (
    <>
        {mapFilters.closeFilter ? (
            <Button
                className="filters-open-icon"
                colorScheme="pink"
                onClick={() => {
                    mapFilters.setCloseFilter(false);
                }
                }
            >
                Filters
            </Button>
        ) : (
            <div className="filter">
      <div className="filter__header">
        <h2 className="filter-title">Filters</h2>
        <ButtonGroup>
          <IconButton 
          aria-label="center back" 
          icon={<FaTimes />} 
            onClick={() => {
                mapFilters.setCloseFilter(true);
            }}

          />
        </ButtonGroup>
      </div>
      {mapFilters.filters.map((item, index) => {
        return (
          <FormSelect
            key={index}
            placeholder={item.placeholder}
            options={item.options}
          />
        );
      })}
    </div>
        )}
    </>
  );
};
